import "../../chunk-5WRI5ZAA.js";

// src/visualBuilder/utils/errorHandling.ts
function hasPostMessageError(obj) {
  return obj?.error === true;
}
export {
  hasPostMessageError
};
//# sourceMappingURL=errorHandling.js.map